import React from 'react';

/**
 * Contenedor individual para un filtro de tipo checkbox con diseño responsivo
 * @param {Object} props - Propiedades del componente
 * @param {React.ReactNode} props.children - Un solo checkbox
 * @param {string} props.className - Clases CSS adicionales (opcional)
 */
const CheckboxFiltersContainer = ({ children, className = '' }) => {
  // Detectar si hay un solo hijo para centrarlo
  const childrenArray = React.Children.toArray(children);
  const isSingleChild = childrenArray.length === 1;
  
  return (
    <div className={`
      bg-gray-700/30 
      border 
      border-gray-600/50 
      rounded-lg 
      pl-1
      pr-2
      py-2
      
      /* Contenedor inline que se adapta al contenido */
      inline-flex 
      items-center
      
      /* Altura consistente con otros elementos del FilterBar */
      h-10
      
      ${className}
    `}>
      {children}
    </div>
  );
};

export default CheckboxFiltersContainer;
